import { AddClientForm } from "@/features/clients/components/add-client-form";
import { FirmContextBanner } from "@/features/clients/components/firm-context-banner";
import { useFirmContext } from "@/features/clients/hooks/use-firm-context";

export default function NewClientPage() {
  const { actingFirmId, actingFirmName } = useFirmContext();
  return (
    <div className="flex flex-col gap-6">
      <div>
        <nav className="text-muted-foreground mb-1 flex text-sm">
          <span>Clients</span>
          <span className="mx-2">/</span>
          <span className="text-foreground font-medium">New Client</span>
        </nav>
        <h1 className="text-primary text-3xl font-bold">New Client</h1>
        <p className="text-muted-foreground mt-1 text-sm">
          Add an individual or business client, then complete their profile.
        </p>
      </div>

      {actingFirmId && <FirmContextBanner firmName={actingFirmName} />}

      <AddClientForm />
    </div>
  );
}
